<template>
  <NewsListPage
    title="其他新闻"
    category-name="其它新闻"
    category-path="other"
    root-class="other-news"
    :page-size="6"
  />
</template>

<script>
  import NewsListPage from '../components/NewsListPage.vue'

  export default {
    name: 'OtherNews',
    components: { NewsListPage }
  }
</script>